"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _withState = _interopRequireDefault(require("recompose/withState"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _Panel = _interopRequireDefault(require("angieslist-react-components/lib/Panel"));
var _ButtonToolbar = _interopRequireDefault(require("angieslist-react-components/lib/ButtonToolbar"));
var _ButtonGroup = _interopRequireDefault(require("angieslist-react-components/lib/ButtonGroup"));
var _contactPreferencesModal = _interopRequireDefault(require("./modals/contactPreferencesModal"));
var ContactPreferences = function ContactPreferences(_ref) {
  var userId = _ref.userId,
    email = _ref.email,
    editButtonStyle = _ref.editButtonStyle,
    cancelButtonStyle = _ref.cancelButtonStyle,
    showContactPrefModal = _ref.showContactPrefModal,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal;
  var handleShow = function handleShow() {
    return setShowModal(true);
  };
  var handleClose = function handleClose() {
    return setShowModal(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Email & Phone Preferences")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, /*#__PURE__*/_react["default"].createElement("p", null, "Choose how you'd like to receive alerts and information from Angi."), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], null, /*#__PURE__*/_react["default"].createElement(_contactPreferencesModal["default"], {
    userId: userId,
    email: email,
    editButtonStyle: editButtonStyle,
    cancelButtonStyle: cancelButtonStyle,
    showModalOverlay: showContactPrefModal,
    showModal: showModal,
    handleClose: handleClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "contact-preferences--edit-button",
    bsSize: "small",
    flat: true,
    bsStyle: editButtonStyle,
    style: {
      fontWeight: 'bold'
    },
    onClick: handleShow
  }, "Manage Preferences"))))));
};
ContactPreferences.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  cancelButtonStyle: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  showContactPrefModal: _propTypes["default"].bool.isRequired,
  showModal: _propTypes["default"].bool.isRequired,
  setShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showModal', 'setShowModal', false), _pure["default"])(ContactPreferences);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/contactPreferences.js
// module id = 4291
// module chunks = 9